import React, { ChangeEvent } from 'react'
import { Spinner } from 'theme-ui'
import { InputComponent, InputComponentProps } from './Input'

interface InputFileProps extends Omit<InputComponentProps, 'onChange'> {
  onChange?(data: {
    base64: string | ArrayBuffer
    e: ChangeEvent<HTMLInputElement>
  }): void
  loading?: boolean
}

export default function InputFile({ loading, ...props }: InputFileProps) {
  function handleChange(e) {
    const reader = new FileReader()
    const file = e.target.files?.[0]

    reader.onload = () => {
      props.onChange?.({ base64: reader.result, e })
    }

    reader.readAsDataURL(file)
  }

  return (
    <>
      <InputComponent
        icon={loading && <Spinner />}
        onClick={loading ? (e) => e.preventDefault() : undefined}
        {...props}
        type="file"
        onChange={handleChange}
        multiple={false}
      />
    </>
  )
}
